import React from 'react';
import clsx from 'clsx';
import { ls } from '../../../locale';
import { Checkbox } from '../../../comps/checkbox';
import { numberFormatter } from '../../../helpers';
import { AnciService } from '../../../state/models/Ancillary';

type PriceBoxProps = {
  service: AnciService;
  selected: boolean;
  included: boolean;
  purchased: boolean;
  currencyCode: string;
  hideDescription?: boolean;
  onClick: (service: any) => void;
};

export function PriceBox({service, selected, included, purchased, currencyCode, hideDescription, onClick}: PriceBoxProps) {

  const handleClick = () => {
    if(included || purchased) return;
    
    if(typeof onClick === 'function') {
      onClick(service);
    }
  }

  const rCommon = ls.t('Common');
  const amount = numberFormatter.formatCurrency(service.amount)

  return (
    <div 
      className={clsx('tw-flex tw-flex-row md:tw-flex-col tw-mb-[1px] md:tw-mb-0 md:tw-justify-center tw-items-center tw-gap-4 md:tw-gap-0 md:tw-min-w-40 tw-p-4',
        'tw-cursor-pointer',
        !included && !purchased ? 'hover:tw-shadow-inset-blue' : '',
        'tw-border-0 tw-border-t tw-border-solid tw-border-gray-200 md:tw-border-t-0',
        selected && !included && !purchased ? 'tw-shadow-inset-blue' : 'tw-border-0 md:tw-border-x tw-border-solid tw-border-gray-200',
      )} 
      onClick={handleClick}
    >
      <div className='tw-block tw-grow md:tw-hidden tw-text-lg tw-ps-2'>{ service.description }</div>
      { !included && !purchased && <div className='tw-text-lg md:tw-text-sm tw-font-bold sa-text-green'>{currencyCode} {amount}</div>}
      <div className='tw-hidden md:tw-block tw-text-[10px] tw-mb-3'>{hideDescription ? "" : service.description}</div>
      { included || purchased ? <span className='included'>{included ? rCommon.Included : rCommon.Purchased}</span> : <Checkbox checked={selected} /> }
    </div>
  )
}